import "./marquee.css";

const Marquee = ({ onClick }) => {
  return (
    <div>
      <marquee className="marquee">
        <span onClick={onClick} style={{ cursor: "pointer" }}>
          Admissions Open for 2025-26
        </span>
      </marquee>
    </div>
  );
};

export default Marquee;
